/* eslint-disable no-unused-vars */
import { QueryClient, QueryClientConfig, useQueryClient } from '@tanstack/react-query'

export enum QUERY_DATA {
  MAGAZINE = 'magazine',
  RESELLER = 'reseller',
  PRODUCT_BY_SKU = 'productBySku',
  PRODUCTS = 'products',
  SHOP_CART = 'order_list',
  SHOP_CART_TOTAL = 'totalItemsCart',
  CONFIG_CAT = 'configCat',
  IMAGE = 'catalogImage',
  CYCLE = 'cycle',
  RESELLER_BY_EXTERNAL_ID = 'RESELLER_BY_EXTERNAL_ID',
  RESELLER_FROM_ORDER_ID = 'RESELLER_FROM_ORDER_ID',
  PROMPT_DELIVERY = 'promptDelivery',
  BEST_SELLERS = 'bestSellers',
  ON_SALE = 'onSale',
}

export const queryConfig = {
  retry: 1,
  refetchOnWindowFocus: false,
}

export const createQueryClient = (config?: QueryClientConfig) => new QueryClient(config)

export const queryClient = createQueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
})

export { useQueryClient }
